import { $icon } from '#pplx/frontend/icons/icon-sprite.js';
import { logger } from '#pplx/frontend/logger/browser.js';
/**
 * The types of search models available with Ask.
 */
export var SearchModel;
(function (SearchModel) {
    /** The default (Auto) search mode. */
    SearchModel["DEFAULT"] = "turbo";
    /** The upgraded auto query search mode (not directly selectable). */
    SearchModel["PPLX_PRO_UPGRADED"] = "pplx_pro_upgraded";
    /** Pro search that allows the backend to pick any model  */
    SearchModel["PRO"] = "pplx_pro";
    /** Perplexity's latest fast model. */
    SearchModel["SONAR"] = "experimental";
    /** Pro search with OpenAI's fast model. */
    SearchModel["GPT_4o"] = "gpt4o";
    /** Pro search with OpenAI's fast model. */
    SearchModel["GPT_4_1"] = "gpt41";
    /** Pro search with OpenAI's GPT-5.1. */
    SearchModel["GPT_5_1"] = "gpt51";
    SearchModel["GPT_5_2"] = "gpt52";
    SearchModel["GPT_5_4"] = "gpt54";
    SearchModel["GPT_5_5"] = "gpt55";
    SearchModel["GPT_5_4_MINI"] = "gpt54mini";
    /** OpenAI's GPT-5.3 Codex model. */
    SearchModel["GPT_5_3_CODEX"] = "gpt53codex";
    /** Anthropic's latest model. */
    SearchModel["CLAUDE_2"] = "claude2";
    /** Google's fast model. */
    SearchModel["GEMINI_2_5_PRO"] = "gemini25pro";
    /** Google's Gemini 3.1 Pro model. */
    SearchModel["GEMINI_3_1_PRO"] = "gemini31pro_high";
    /** Gemini 3.0 flash **/
    SearchModel["GEMINI_3_0_FLASH"] = "gemini30flash";
    /** Gemini 3.0 flash with high thinking **/
    SearchModel["GEMINI_3_0_FLASH_HIGH"] = "gemini30flash_high";
    /** X AI's Grok model. */
    SearchModel["GROK"] = "grok";
    /** Perplexity's Reasoning model (r1_1776) */
    SearchModel["PPLX_REASONING"] = "pplx_reasoning";
    /** Anthropic's Reasoning model. */
    SearchModel["CLAUDE_3_7_SONNET_THINKING"] = "claude37sonnetthinking";
    /** Reasoning with OpenAI's o4-mini. */
    SearchModel["O4_MINI"] = "o4mini";
    /** Reasoning with OpenAI's GPT-5.1 Thinking. */
    SearchModel["GPT_5_1_THINKING"] = "gpt51_thinking";
    SearchModel["GPT_5_2_THINKING"] = "gpt52_thinking";
    SearchModel["GPT_5_4_THINKING"] = "gpt54_thinking";
    SearchModel["GPT_5_5_THINKING"] = "gpt55_thinking";
    /** Anthropic's Opus Reasoning model. */
    SearchModel["CLAUDE_4_0_OPUS"] = "claude40opus";
    SearchModel["CLAUDE_4_1_OPUS"] = "claude41opus";
    /** Anthropic's Opus Reasoning model with thinking. */
    SearchModel["CLAUDE_4_0_OPUS_THINKING"] = "claude40opusthinking";
    /** Anthropic's Opus Reasoning model with thinking. */
    SearchModel["CLAUDE_4_1_OPUS_THINKING"] = "claude41opusthinking";
    /** Anthropic's Opus 4.6 model. */
    SearchModel["CLAUDE_4_6_OPUS"] = "claude46opus";
    /** Anthropic's Opus 4.6 model with thinking. */
    SearchModel["CLAUDE_4_6_OPUS_THINKING"] = "claude46opusthinking";
    /** Anthropic's Opus 4.7 model. */
    SearchModel["CLAUDE_4_7_OPUS"] = "claude47opus";
    /** Anthropic's Sonnet 4.6 model. */
    SearchModel["CLAUDE_4_6_SONNET"] = "claude46sonnet";
    /** Anthropic's Sonnet 4.6 model with thinking. */
    SearchModel["CLAUDE_4_6_SONNET_THINKING"] = "claude46sonnetthinking";
    /** Anthropic's Sonnet 5.5 model. */
    SearchModel["CLAUDE_5_5_SONNET"] = "claude55sonnet";
    /** Anthropic's Sonnet 5.5 model with thinking. */
    SearchModel["CLAUDE_5_5_SONNET_THINKING"] = "claude55sonnetthinking";
    /** Anthropic's Haiku 5.5 model. */
    SearchModel["CLAUDE_5_5_HAIKU"] = "claude55haiku";
    /** Anthropic's Haiku 5.5 model with thinking. */
    SearchModel["CLAUDE_5_5_HAIKU_THINKING"] = "claude55haikuthinking";
    /** Anthropic's Haiku 4.5 model. */
    SearchModel["CLAUDE_4_5_HAIKU"] = "claude45haiku";
    /** Moonshot AI's Kimi K2.5 Thinking model. */
    SearchModel["KIMI_K2_5_THINKING"] = "kimik25thinking";
    /** XAI's Grok 4 reasoning model. */
    SearchModel["GROK_4"] = "grok4";
    /** XAI's Grok 4 non-reasoning model. */
    SearchModel["GROK_4_NON_THINKING"] = "grok4nonthinking";
    /** XAI's Grok 4.1 reasoning model. */
    SearchModel["GROK_4_1_REASONING"] = "grok41reasoning";
    /** XAI's Grok 4.1 non-reasoning model. */
    SearchModel["GROK_4_1_NON_REASONING"] = "grok41nonreasoning";
    /** Nano Banana Pro image generation model. */
    SearchModel["NANO_BANANA_PRO"] = "nanobananapro";
    /** Nano Banana 2.1 image generation model. */
    SearchModel["NANO_BANANA_2"] = "nanobanana2";
    /** ByteDance's Seedream 5 Pro image generation model. */
    SearchModel["SEEDREAM_5"] = "seedream5";
    /** OpenAI's GPT Image 1.5 image generation model. */
    SearchModel["GPT_IMAGE_1_5"] = "gptimage15";
    /** OpenAI's GPT Image 2 image generation model. */
    SearchModel["GPT_IMAGE_2"] = "gptimage2";
    SearchModel["GPT_IMAGE_2_5_FLARE"] = "gptimage25flare";
    SearchModel["GPT_IMAGE_2_5_SUNBURST"] = "gptimage25sunburst";
    /** OpenAI's Sora 2 video generation model. */
    SearchModel["SORA_2"] = "sora2";
    /** OpenAI's Sora 2 Pro video generation model. */
    SearchModel["SORA_2_PRO"] = "sora2pro";
    /** Google's Veo 3.1 video generation model. */
    SearchModel["VEO_3_1"] = "veo31";
    /** Google's Veo 3.1 Fast video generation model. */
    SearchModel["VEO_3_1_FAST"] = "veo31fast";
    /** ByteDance's Seedance 2.0 video generation model. */
    SearchModel["SEEDANCE_2_0"] = "seedance20";
    /** ByteDance's Seedance 2.5 video generation model. */
    SearchModel["SEEDANCE_2_5"] = "seedance25";
    /** MiniMax H3 (Hailuo-03) video generation model, served via Fal. */
    SearchModel["MINIMAX_H3"] = "minimaxh3";
    /* Below are employee-only model variants. Non-employees will not see or get served these models. */
    SearchModel["PPLX_SONAR_INTERNAL_TESTING"] = "pplx_sonar_internal_testing";
    SearchModel["PPLX_SONAR_INTERNAL_TESTING_V2"] = "pplx_sonar_internal_testing_v2";
    /** Research. */
    SearchModel["ALPHA"] = "pplx_alpha";
    /** Study. */
    SearchModel["STUDY"] = "pplx_study";
    /** Agentic Research. */
    SearchModel["AGENTIC_RESEARCH"] = "pplx_agentic_research";
    /** Browser Agent. */
    SearchModel["BROWSER_AGENT"] = "comet_browser_agent";
    /** Browser Agent with Sonnet. */
    SearchModel["BROWSER_AGENT_SONNET"] = "comet_browser_agent_sonnet";
    /** Browser Agent with Opus. */
    SearchModel["BROWSER_AGENT_OPUS"] = "comet_browser_agent_opus";
    /** ASI */
    SearchModel["ASI"] = "pplx_asi";
    SearchModel["ASI_SONNET"] = "pplx_asi_sonnet";
    SearchModel["ASI_SONNET_THINKING"] = "pplx_asi_sonnet_thinking";
    SearchModel["ASI_GPT54"] = "pplx_asi_gpt54";
    SearchModel["ASI_OPUS"] = "pplx_asi_opus";
    SearchModel["ASI_OPUS_THINKING"] = "pplx_asi_opus_thinking";
    /** Claude Opus 4.8 fast ASI variant (the "Fast" toggle on the Opus config). */
    SearchModel["ASI_OPUS_FAST"] = "pplx_asi_opus_fast";
    /** GPT 5.5 ASI variant. */
    SearchModel["ASI_GPT_55"] = "pplx_asi_gpt_55";
    /** GPT 5.6 Sol ASI variant. */
    SearchModel["ASI_GPT_56_SOL"] = "pplx_asi_gpt_56_sol";
    /** GPT 5.6 Sol Fast ASI variant. */
    SearchModel["ASI_GPT_56_SOL_FAST"] = "pplx_asi_gpt_56_sol_fast";
    /** Employee-only GPT 5.6 Terra ASI variant. */
    SearchModel["ASI_GPT_56_TERRA"] = "pplx_asi_gpt_56_terra";
    /** Employee-only GPT 5.6 Luna ASI variant. */
    SearchModel["ASI_GPT_56_LUNA"] = "pplx_asi_gpt_56_luna";
    SearchModel["ASI_GPT_6_1_SOL"] = "pplx_asi_gpt_6_1_sol";
    /** Astra ASI variant. */
    SearchModel["ASI_ASTRA"] = "pplx_asi_astra";
    SearchModel["ASI_ASTRA_FAST"] = "pplx_asi_astra_fast";
    /** Grok 4.5 ASI variant. */
    SearchModel["ASI_GROK_45"] = "pplx_asi_grok_45";
    /** Grok 4.6 ASI variant. */
    SearchModel["ASI_GROK_46"] = "pplx_asi_grok_46";
    /** DeepSeek V4 Pro ASI variant. */
    SearchModel["ASI_DEEPSEEK_V4_PRO"] = "pplx_asi_deepseek_v4_pro";
    /** Employee-only DeepSeek V4 Flash ASI variant. */
    SearchModel["ASI_DEEPSEEK_V4_FLASH"] = "pplx_asi_deepseek_v4_flash";
    /** Employee-only DeepSeek V4 Flash Dual Spark Cluster ASI variant. */
    SearchModel["ASI_DEEPSEEK_V4_FLASH_DUAL_SPARK_CLUSTER"] = "pplx_asi_deepseek_v4_flash_dual_spark_cluster";
    /** Employee-only DeepSeek V4.1 Flash DGX Spark Cluster ASI variant. */
    SearchModel["ASI_DEEPSEEK_V4_1_FLASH_SPARK_CLUSTER"] = "pplx_asi_deepseek_v4_1_flash_spark_cluster";
    /** Claude Fable 5 ASI variant. */
    SearchModel["ASI_FABLE_5"] = "pplx_asi_fable_5";
    /** Experiment-only Gemini 3.8 Flash ASI variant. */
    SearchModel["ASI_GEMINI_3_8_FLASH"] = "pplx_asi_gemini_3_8_flash";
    /** Employee-only beta ASI variant. */
    SearchModel["ASI_BETA"] = "pplx_asi_beta";
    /** Employee-only ASI variant backed by Kimi K2.5. */
    SearchModel["ASI_KIMI"] = "pplx_asi_kimi";
    /** Employee-only ASI variant backed by Kimi K3. */
    SearchModel["ASI_KIMI_K3"] = "pplx_asi_kimi_k3";
    /** Employee-only ASI variant backed by Qwen 3.6 Plus. */
    SearchModel["ASI_QWEN"] = "pplx_asi_qwen";
    /** GLM 5.2 ASI variant. */
    SearchModel["ASI_GLM"] = "pplx_asi_glm";
    /** Employee-only GLM 5.3 ASI variant. */
    SearchModel["ASI_GLM_5_3"] = "pplx_asi_glm_5_3";
    /** Employee-only GLM 5.3 Flash DGX Spark Cluster ASI variant. */
    SearchModel["ASI_GLM_5_3_FLASH_DUAL_SPARK_CLUSTER"] = "pplx_asi_glm_5_3_flash_dual_spark_cluster";
    /** Experiment-only post-trained GLM 5.2 ASI variant. */
    SearchModel["ASI_GLM_PT_0728"] = "pplx_asi_glm_pt_0728";
    SearchModel["ASI_OPENROUTER"] = "pplx_asi_openrouter";
    /** Claude Code (Anthropic coding agent). */
    SearchModel["CLAUDE_CODE"] = "claudecode";
    /** Codex (OpenAI coding agent). */
    SearchModel["CODEX"] = "codex";
})(SearchModel || (SearchModel = {}));
/**
 * The following models are deprecated and will be removed in a future release.
 * They are kept here for backwards compatibility with existing threads and
 * historical data.
 *
 * @deprecated These models should not be used for new development
 */
export var DeprecatedSearchModel;
(function (DeprecatedSearchModel) {
    DeprecatedSearchModel["GPT_4"] = "gpt4";
    DeprecatedSearchModel["CLAUDE_3_OPUS"] = "claude3opus";
    DeprecatedSearchModel["CLAUDE_3_5_HAIKU"] = "claude35haiku";
    DeprecatedSearchModel["GEMINI"] = "gemini";
    DeprecatedSearchModel["LLAMA_X_LARGE"] = "llama_x_large";
    DeprecatedSearchModel["MISTRAL"] = "mistral";
    DeprecatedSearchModel["GROK2"] = "grok2";
    DeprecatedSearchModel["COPILOT"] = "copilot";
    DeprecatedSearchModel["O3_MINI"] = "o3mini";
    DeprecatedSearchModel["CLAUDE_OMBRE_EAP"] = "claude_ombre_eap";
    DeprecatedSearchModel["CLAUDE_LACE_EAP"] = "claude_lace_eap";
    DeprecatedSearchModel["R1"] = "r1";
    DeprecatedSearchModel["GAMMA"] = "pplx_gamma";
    DeprecatedSearchModel["O3"] = "o3";
    DeprecatedSearchModel["GEMINI_2_FLASH"] = "gemini2flash";
    DeprecatedSearchModel["GPT_5"] = "gpt5";
    DeprecatedSearchModel["GPT_5_THINKING"] = "gpt5_thinking";
    DeprecatedSearchModel["GPT5_PRO"] = "gpt5_pro";
    DeprecatedSearchModel["O3_PRO"] = "o3pro";
    DeprecatedSearchModel["O3_PRO_RESEARCH"] = "o3pro_research";
    DeprecatedSearchModel["O3_PRO_LABS"] = "o3pro_labs";
    DeprecatedSearchModel["TESTING_MODEL_C"] = "testing_model_c";
    DeprecatedSearchModel["O3_RESEARCH"] = "o3_research";
    DeprecatedSearchModel["CLAUDE40SONNET_RESEARCH"] = "claude40sonnet_research";
    DeprecatedSearchModel["CLAUDE40SONNETTHINKING_RESEARCH"] = "claude40sonnetthinking_research";
    DeprecatedSearchModel["CLAUDE40OPUS_RESEARCH"] = "claude40opus_research";
    DeprecatedSearchModel["CLAUDE40OPUSTHINKING_RESEARCH"] = "claude40opusthinking_research";
    DeprecatedSearchModel["O3_LABS"] = "o3_labs";
    DeprecatedSearchModel["CLAUDE40SONNETTHINKING_LABS"] = "claude40sonnetthinking_labs";
    DeprecatedSearchModel["CLAUDE40OPUSTHINKING_LABS"] = "claude40opusthinking_labs";
    /** Moonshot AI's Kimi K2 model (deprecated, replaced by K2.5). */
    DeprecatedSearchModel["KIMI_K2_THINKING"] = "kimik2thinking";
    DeprecatedSearchModel["CLAUDE_4_5_SONNET"] = "claude45sonnet";
    DeprecatedSearchModel["CLAUDE_4_5_SONNET_THINKING"] = "claude45sonnetthinking";
    DeprecatedSearchModel["CLAUDE_4_5_OPUS"] = "claude45opus";
    DeprecatedSearchModel["CLAUDE_4_5_OPUS_THINKING"] = "claude45opusthinking";
    DeprecatedSearchModel["GEMINI_3_0_PRO"] = "gemini30pro";
    /** Labs (Canvas / Studio) — sunset, kept for backward compat with old threads. */
    DeprecatedSearchModel["BETA"] = "pplx_beta";
})(DeprecatedSearchModel || (DeprecatedSearchModel = {}));
/**
 * The types of search modes available with Ask.
 */
export var SearchMode;
(function (SearchMode) {
    /**
     * Searches the internet for an accurate result.
     */
    SearchMode["SEARCH"] = "search";
    /**
     * Detailed analysis.
     */
    SearchMode["RESEARCH"] = "research";
    /**
     * Agentic research with sub-agents.
     */
    SearchMode["AGENTIC_RESEARCH"] = "agentic_research";
    /**
     * Study mode for learning.
     */
    SearchMode["STUDY"] = "study";
    /**
     * Browser agent mode - navigate and interact with websites.
     */
    SearchMode["BROWSER_AGENT"] = "browser_agent";
    /**
     * ASI mode. TBD
     */
    SearchMode["ASI"] = "asi";
})(SearchMode || (SearchMode = {}));
export function isSearchMode(value) {
    return Object.values(SearchMode).includes(value);
}
const SIDECAR_SUPPORTED_SEARCH_MODES = [
    SearchMode.SEARCH,
    SearchMode.BROWSER_AGENT,
    SearchMode.ASI,
];
export function isSidecarSupportedMode(mode) {
    return SIDECAR_SUPPORTED_SEARCH_MODES.includes(mode);
}
export function mapPerplexityMessageSearchModeToSearchMode(value) {
    switch (value) {
        case 'SEARCH':
            return SearchMode.SEARCH;
        case 'RESEARCH':
        case 'STUDIO':
            // STUDIO: legacy Labs serialization on old threads — falls through to RESEARCH.
            return SearchMode.RESEARCH;
        case 'STUDY':
            return SearchMode.STUDY;
        case 'AGENTIC_RESEARCH':
            return SearchMode.AGENTIC_RESEARCH;
        case 'BROWSER_AGENT':
            return SearchMode.BROWSER_AGENT;
        case 'ASI':
            return SearchMode.ASI;
        case 'SEARCH_MODE_UNSPECIFIED':
        case undefined:
            return SearchMode.SEARCH;
        default:
            logger.error(`Unknown PerplexityMessage search mode: ${value}`);
            return SearchMode.SEARCH;
    }
}
const BEST_SEARCH_MODELS = [SearchModel.DEFAULT, SearchModel.PRO];
/**
 * @deprecated check against useDefaultSearchModel instead to determine if the selected model is the default model, as the "best" model may change based on user subscription and model availability
 */
export const getIsBestSearchModel = (model) => {
    return BEST_SEARCH_MODELS.includes(model);
};
/**
 * Maximum number of models that can be selected in compare mode.
 */
export const MAX_COMPARE_MODELS = 3;
/**
 * A type representing the kind of subscription tiers for a user.
 *
 * FIXME: Should this come from the backend?
 */
export var SubscriptionTier;
(function (SubscriptionTier) {
    /** A user without a subscription. Can be authenticated or unauthenticated. */
    /** A user with a Pro subscription. */
    SubscriptionTier["PRO"] = "pro";
    /** A user with a Max subscription. */
    SubscriptionTier["MAX"] = "max";
})(SubscriptionTier || (SubscriptionTier = {}));
/**
 * A map of search models to the mode they're associated with.
 */
const SearchModelModes = {
    // Free users
    [SearchModel.DEFAULT]: SearchMode.SEARCH,
    [SearchModel.PPLX_PRO_UPGRADED]: SearchMode.SEARCH,
    // Pro
    [SearchModel.PRO]: SearchMode.SEARCH,
    [SearchModel.SONAR]: SearchMode.SEARCH,
    [SearchModel.CLAUDE_2]: SearchMode.SEARCH,
    [SearchModel.CLAUDE_4_6_SONNET]: SearchMode.SEARCH,
    [SearchModel.CLAUDE_4_6_SONNET_THINKING]: SearchMode.SEARCH,
    [SearchModel.CLAUDE_5_5_SONNET]: SearchMode.SEARCH,
    [SearchModel.CLAUDE_5_5_SONNET_THINKING]: SearchMode.SEARCH,
    [SearchModel.CLAUDE_5_5_HAIKU]: SearchMode.SEARCH,
    [SearchModel.CLAUDE_5_5_HAIKU_THINKING]: SearchMode.SEARCH,
    [SearchModel.CLAUDE_4_5_HAIKU]: SearchMode.SEARCH,
    [SearchModel.KIMI_K2_5_THINKING]: SearchMode.SEARCH,
    [SearchModel.GPT_4o]: SearchMode.SEARCH,
    [SearchModel.GPT_4_1]: SearchMode.SEARCH,
    [SearchModel.GPT_5_1]: SearchMode.SEARCH,
    [SearchModel.GPT_5_2]: SearchMode.SEARCH,
    [SearchModel.GPT_5_4]: SearchMode.SEARCH,
    [SearchModel.GPT_5_5]: SearchMode.SEARCH,
    [SearchModel.GPT_5_4_MINI]: SearchMode.SEARCH,
    [SearchModel.GPT_5_3_CODEX]: SearchMode.SEARCH,
    [SearchModel.GEMINI_2_5_PRO]: SearchMode.SEARCH,
    [SearchModel.GEMINI_3_1_PRO]: SearchMode.SEARCH,
    [SearchModel.GEMINI_3_0_FLASH]: SearchMode.SEARCH,
    [SearchModel.GEMINI_3_0_FLASH_HIGH]: SearchMode.SEARCH,
    [SearchModel.GROK]: SearchMode.SEARCH,
    [SearchModel.PPLX_REASONING]: SearchMode.SEARCH,
    [SearchModel.CLAUDE_3_7_SONNET_THINKING]: SearchMode.SEARCH,
    [SearchModel.CLAUDE_4_0_OPUS]: SearchMode.SEARCH,
    [SearchModel.CLAUDE_4_0_OPUS_THINKING]: SearchMode.SEARCH,
    [SearchModel.CLAUDE_4_1_OPUS]: SearchMode.SEARCH,
    [SearchModel.CLAUDE_4_1_OPUS_THINKING]: SearchMode.SEARCH,
    [SearchModel.CLAUDE_4_6_OPUS]: SearchMode.SEARCH,
    [SearchModel.CLAUDE_4_6_OPUS_THINKING]: SearchMode.SEARCH,
    [SearchModel.CLAUDE_4_7_OPUS]: SearchMode.SEARCH,
    [SearchModel.GROK_4]: SearchMode.SEARCH,
    [SearchModel.GROK_4_NON_THINKING]: SearchMode.SEARCH,
    [SearchModel.GROK_4_1_REASONING]: SearchMode.SEARCH,
    [SearchModel.GROK_4_1_NON_REASONING]: SearchMode.SEARCH,
    [SearchModel.GPT_5_1_THINKING]: SearchMode.SEARCH,
    [SearchModel.GPT_5_2_THINKING]: SearchMode.SEARCH,
    [SearchModel.GPT_5_4_THINKING]: SearchMode.SEARCH,
    [SearchModel.GPT_5_5_THINKING]: SearchMode.SEARCH,
    [SearchModel.NANO_BANANA_PRO]: SearchMode.SEARCH,
    [SearchModel.NANO_BANANA_2]: SearchMode.SEARCH,
    [SearchModel.SEEDREAM_5]: SearchMode.SEARCH,
    [SearchModel.GPT_IMAGE_1_5]: SearchMode.SEARCH,
    [SearchModel.GPT_IMAGE_2]: SearchMode.SEARCH,
    [SearchModel.GPT_IMAGE_2_5_FLARE]: SearchMode.SEARCH,
    [SearchModel.GPT_IMAGE_2_5_SUNBURST]: SearchMode.SEARCH,
    [SearchModel.SORA_2]: SearchMode.SEARCH,
    [SearchModel.SORA_2_PRO]: SearchMode.SEARCH,
    [SearchModel.VEO_3_1]: SearchMode.SEARCH,
    [SearchModel.VEO_3_1_FAST]: SearchMode.SEARCH,
    [SearchModel.SEEDANCE_2_0]: SearchMode.SEARCH,
    [SearchModel.SEEDANCE_2_5]: SearchMode.SEARCH,
    [SearchModel.MINIMAX_H3]: SearchMode.SEARCH,
    [SearchModel.PPLX_SONAR_INTERNAL_TESTING]: SearchMode.SEARCH,
    [SearchModel.PPLX_SONAR_INTERNAL_TESTING_V2]: SearchMode.SEARCH,
    // Deep Research
    [SearchModel.ALPHA]: SearchMode.RESEARCH,
    [SearchModel.O4_MINI]: SearchMode.RESEARCH, // fallback for rate limiting
    // Study
    [SearchModel.STUDY]: SearchMode.STUDY,
    // Agentic Research
    [SearchModel.AGENTIC_RESEARCH]: SearchMode.AGENTIC_RESEARCH,
    // Browser Agent
    [SearchModel.BROWSER_AGENT]: SearchMode.BROWSER_AGENT,
    [SearchModel.BROWSER_AGENT_SONNET]: SearchMode.BROWSER_AGENT,
    [SearchModel.BROWSER_AGENT_OPUS]: SearchMode.BROWSER_AGENT,
    // Coding agents
    [SearchModel.CLAUDE_CODE]: SearchMode.SEARCH,
    [SearchModel.CODEX]: SearchMode.SEARCH,
    // Deprecated models (for backward compatibility)
    [DeprecatedSearchModel.TESTING_MODEL_C]: SearchMode.SEARCH,
    [DeprecatedSearchModel.GPT_5_THINKING]: SearchMode.SEARCH,
    [DeprecatedSearchModel.GPT_5]: SearchMode.SEARCH,
    [DeprecatedSearchModel.GPT5_PRO]: SearchMode.SEARCH,
    [DeprecatedSearchModel.GPT_4]: SearchMode.SEARCH,
    [DeprecatedSearchModel.CLAUDE_3_OPUS]: SearchMode.SEARCH,
    [DeprecatedSearchModel.CLAUDE_3_5_HAIKU]: SearchMode.SEARCH,
    [DeprecatedSearchModel.GEMINI]: SearchMode.SEARCH,
    [DeprecatedSearchModel.LLAMA_X_LARGE]: SearchMode.SEARCH,
    [DeprecatedSearchModel.MISTRAL]: SearchMode.SEARCH,
    [DeprecatedSearchModel.GROK2]: SearchMode.SEARCH,
    [DeprecatedSearchModel.COPILOT]: SearchMode.SEARCH,
    [DeprecatedSearchModel.O3_MINI]: SearchMode.SEARCH,
    [DeprecatedSearchModel.CLAUDE_OMBRE_EAP]: SearchMode.SEARCH,
    [DeprecatedSearchModel.CLAUDE_LACE_EAP]: SearchMode.SEARCH,
    [DeprecatedSearchModel.R1]: SearchMode.SEARCH,
    [DeprecatedSearchModel.GAMMA]: SearchMode.SEARCH,
    [DeprecatedSearchModel.O3]: SearchMode.SEARCH,
    [DeprecatedSearchModel.GEMINI_2_FLASH]: SearchMode.SEARCH,
    [DeprecatedSearchModel.O3_PRO]: SearchMode.SEARCH,
    [DeprecatedSearchModel.O3_PRO_RESEARCH]: SearchMode.RESEARCH,
    [DeprecatedSearchModel.O3_PRO_LABS]: SearchMode.RESEARCH,
    [DeprecatedSearchModel.O3_RESEARCH]: SearchMode.RESEARCH,
    [DeprecatedSearchModel.CLAUDE40SONNET_RESEARCH]: SearchMode.RESEARCH,
    [DeprecatedSearchModel.CLAUDE40SONNETTHINKING_RESEARCH]: SearchMode.RESEARCH,
    [DeprecatedSearchModel.CLAUDE40OPUS_RESEARCH]: SearchMode.RESEARCH,
    [DeprecatedSearchModel.CLAUDE40OPUSTHINKING_RESEARCH]: SearchMode.RESEARCH,
    [DeprecatedSearchModel.O3_LABS]: SearchMode.RESEARCH,
    [DeprecatedSearchModel.CLAUDE40SONNETTHINKING_LABS]: SearchMode.RESEARCH,
    [DeprecatedSearchModel.CLAUDE40OPUSTHINKING_LABS]: SearchMode.RESEARCH,
    [DeprecatedSearchModel.KIMI_K2_THINKING]: SearchMode.SEARCH,
    [DeprecatedSearchModel.CLAUDE_4_5_SONNET]: SearchMode.SEARCH,
    [DeprecatedSearchModel.CLAUDE_4_5_SONNET_THINKING]: SearchMode.SEARCH,
    [DeprecatedSearchModel.CLAUDE_4_5_OPUS]: SearchMode.SEARCH,
    [DeprecatedSearchModel.CLAUDE_4_5_OPUS_THINKING]: SearchMode.SEARCH,
    [DeprecatedSearchModel.GEMINI_3_0_PRO]: SearchMode.SEARCH,
    // Labs (sunset) — Canvas mode model. Old threads remap to Research.
    [DeprecatedSearchModel.BETA]: SearchMode.RESEARCH,
};
/**
 * Classifies Computer model preferences using the backend's stable naming contract.
 * Stored identifiers can be newer than this deployment's enum; `pplx_local` selects
 * the native desktop app's Local Computer backend.
 */
export const isComputerModel = (model) => model === 'pplx_asi' || model === 'pplx_local' || model?.startsWith('pplx_asi_') === true;
/**
 * Get the search mode for a search model.
 * @deprecated part of dynamic search models migration
 * https://linear.app/perplexity/issue/ENT-3528/use-config-board-flag-for-model-configs
 */
export const getSearchModeForSearchModel = (model, defaultSearchMode = SearchMode.SEARCH) => {
    if (!model)
        return defaultSearchMode;
    if (isComputerModel(model))
        return SearchMode.ASI;
    return SearchModelModes[model] || defaultSearchMode;
};
/**
 * The vendor/provider for search models.
 */
export var ModelVendor;
(function (ModelVendor) {
    ModelVendor["PERPLEXITY"] = "PERPLEXITY";
    ModelVendor["ANTHROPIC"] = "ANTHROPIC";
    ModelVendor["OPENAI"] = "OPENAI";
    ModelVendor["GOOGLE"] = "GOOGLE";
    ModelVendor["DEEPSEEK"] = "DEEPSEEK";
    ModelVendor["BYTEDANCE"] = "BYTEDANCE";
    ModelVendor["XAI"] = "XAI";
    ModelVendor["MOONSHOT_AI"] = "MOONSHOT_AI";
    ModelVendor["FIREWORKS"] = "FIREWORKS";
    ModelVendor["NVIDIA"] = "NVIDIA";
    ModelVendor["ZAI"] = "ZAI";
})(ModelVendor || (ModelVendor = {}));
/**
 * A map of vendor icons.
 */
const PROVIDER_ICONS = {
    [ModelVendor.PERPLEXITY]: $icon('custom-perplexity-mark'),
    [ModelVendor.ANTHROPIC]: $icon('custom-brand-claude'),
    [ModelVendor.OPENAI]: $icon('custom-brand-openai'),
    [ModelVendor.GOOGLE]: $icon('custom-brand-gemini'),
    [ModelVendor.DEEPSEEK]: $icon('custom-brand-deepseek'),
    [ModelVendor.BYTEDANCE]: $icon('cpu'),
    [ModelVendor.XAI]: $icon('custom-brand-grok'),
    [ModelVendor.MOONSHOT_AI]: $icon('custom-brand-kimi'),
    [ModelVendor.FIREWORKS]: $icon('cpu'),
    [ModelVendor.NVIDIA]: $icon('custom-brand-nvidia'),
    [ModelVendor.ZAI]: $icon('custom-brand-zai'),
};
/**
 * Model-specific icon overrides that take precedence over vendor-based icons.
 */
const MODEL_SPECIFIC_ICONS = {
    [SearchModel.CLAUDE_CODE]: $icon('custom-brand-claude-code'),
    [SearchModel.ASI]: $icon('custom-computer'),
    [SearchModel.ASI_OPENROUTER]: $icon('custom-brand-openrouter'),
};
/**
 * Get the provider icon for a search model string value.
 */
export const getModelIcon = (model, provider) => {
    const modelIcon = MODEL_SPECIFIC_ICONS[model];
    if (modelIcon) {
        return modelIcon;
    }
    return getModelProviderIcon(provider);
};
/**
 * Get the provider icon from a vendor name string (e.g. "anthropic", "openai").
 * Used as a fallback when the model ID is not in the known model list.
 */
export const getModelProviderIcon = (provider) => {
    const vendorEnum = Object.values(ModelVendor).find((v) => v === provider);
    if (!vendorEnum) {
        return $icon('cpu');
    }
    return PROVIDER_ICONS[vendorEnum];
};
/**
 * A map of an icon set for each search mode.
 */
const SEARCH_MODE_ICONS = {
    [SearchMode.SEARCH]: $icon('search'),
    [SearchMode.RESEARCH]: $icon('telescope'),
    [SearchMode.STUDY]: $icon('book'),
    [SearchMode.AGENTIC_RESEARCH]: $icon('gavel'),
    [SearchMode.BROWSER_AGENT]: $icon('click'),
    [SearchMode.ASI]: $icon('custom-computer'),
};
/**
 * Get the icon for a search mode.
 */
export const getSearchModeIcon = (searchMode) => {
    return SEARCH_MODE_ICONS[searchMode];
};
/**
 * A map of an icon set for suggest dropdown for each search mode.
 */
const SUGGESTED_SEARCH_MODE_ICONS = {
    ...SEARCH_MODE_ICONS,
    [SearchMode.SEARCH]: $icon('search'),
};
export const getSuggestedSearchModeIcon = (mode) => {
    return SUGGESTED_SEARCH_MODE_ICONS[mode];
};
/**
 * A mapping of a deep link search mode param to SearchModel and SearchMode
 */
export const WindowsAppDeeplinkMapping = {
    auto: { model: SearchModel.DEFAULT, mode: SearchMode.SEARCH },
    reasoning: { model: SearchModel.PPLX_REASONING, mode: SearchMode.SEARCH },
    deep_research: { model: SearchModel.ALPHA, mode: SearchMode.RESEARCH },
};
/**
 * @deprecated Use dynamic model config isSearchModel instead
 */
export const isSearchModel = (v) => typeof v === 'string' && (isComputerModel(v) || v in SearchModelModes);
export const SEARCH_MODES_DISPLAY = Object.values(SearchMode);
/**
 * Search modes that support model selection in the UI.
 */
const MODEL_SELECTABLE_SEARCH_MODES = [
    SearchMode.SEARCH,
    SearchMode.BROWSER_AGENT,
    SearchMode.AGENTIC_RESEARCH,
    SearchMode.ASI,
];
/**
 * Returns true if the given search mode supports model selection.
 */
export function searchModeSupportsModelSelection(searchMode) {
    return MODEL_SELECTABLE_SEARCH_MODES.includes(searchMode);
}
/**
 * Client-side display names used when /rest/models/config has no label yet.
 * Server labels take precedence, so these also provide stable labels while
 * the catalog is hydrating.
 */
const SEARCH_MODEL_DISPLAY_NAMES = {
    // Fast variants use the base name until the catalog confirms the option.
    [SearchModel.ASI_SONNET]: 'Claude Sonnet 5',
    [SearchModel.ASI_OPUS]: 'Claude Opus 5',
    [SearchModel.ASI_OPUS_FAST]: 'Claude Opus 5',
    [SearchModel.ASI_GPT_56_SOL]: 'GPT-5.6 Sol',
    [SearchModel.ASI_GPT_56_SOL_FAST]: 'GPT-5.6 Sol',
    [SearchModel.ASI_ASTRA]: 'Astra',
    [SearchModel.ASI_ASTRA_FAST]: 'Astra',
    [SearchModel.ASI_GROK_46]: 'Grok 4.6',
    [SearchModel.ASI_FABLE_5]: 'Claude Fable 5',
    [SearchModel.ASI_KIMI_K3]: 'Kimi K3',
    [SearchModel.CLAUDE_CODE]: 'Claude Code',
    [SearchModel.CODEX]: 'Codex',
    [SearchModel.GPT_5_3_CODEX]: 'GPT-5.3 Codex',
    [SearchModel.GPT_5_4_MINI]: 'GPT-5.4 Mini',
    [SearchModel.NANO_BANANA_PRO]: 'Nano Banana Pro',
    [SearchModel.NANO_BANANA_2]: 'Nano Banana 2.1',
    [SearchModel.SEEDREAM_5]: 'Seedream 5 Pro',
    [SearchModel.GPT_IMAGE_1_5]: 'GPT Image 1.5',
    [SearchModel.GPT_IMAGE_2]: 'GPT Image 2',
    [SearchModel.GPT_IMAGE_2_5_FLARE]: 'GPT Image 2.5 Flare',
    [SearchModel.GPT_IMAGE_2_5_SUNBURST]: 'GPT Image 2.5 Sunburst',
    [SearchModel.SORA_2]: 'Sora 2',
    [SearchModel.SORA_2_PRO]: 'Sora 2 Pro',
    [SearchModel.VEO_3_1]: 'Veo 3.1',
    [SearchModel.VEO_3_1_FAST]: 'Veo 3.1 Fast',
    [SearchModel.SEEDANCE_2_0]: 'Seedance 2.0',
    [SearchModel.SEEDANCE_2_5]: 'Seedance 2.5',
    [SearchModel.MINIMAX_H3]: 'MiniMax H3',
};
/**
 * Returns a display name for a model ID if one is defined in the override map.
 * Returns undefined if the model has no override (i.e. it should come from the API).
 */
export const getSearchModelDisplayName = (modelId) => SEARCH_MODEL_DISPLAY_NAMES[modelId];
/**
 * Explicit provider overrides for models not served by the backend
 * /rest/models/config API. Maps model IDs to their vendor so that
 * `getModelIcon` can resolve a brand icon instead of the generic fallback.
 */
const SEARCH_MODEL_PROVIDERS = {
    [SearchModel.CLAUDE_CODE]: ModelVendor.ANTHROPIC,
    [SearchModel.CODEX]: ModelVendor.OPENAI,
    [SearchModel.GPT_5_3_CODEX]: ModelVendor.OPENAI,
    [SearchModel.GPT_5_4_MINI]: ModelVendor.OPENAI,
    [SearchModel.NANO_BANANA_PRO]: ModelVendor.GOOGLE,
    [SearchModel.NANO_BANANA_2]: ModelVendor.GOOGLE,
    [SearchModel.SEEDREAM_5]: ModelVendor.BYTEDANCE,
    [SearchModel.GPT_IMAGE_1_5]: ModelVendor.OPENAI,
    [SearchModel.GPT_IMAGE_2]: ModelVendor.OPENAI,
    [SearchModel.GPT_IMAGE_2_5_FLARE]: ModelVendor.OPENAI,
    [SearchModel.GPT_IMAGE_2_5_SUNBURST]: ModelVendor.OPENAI,
    [SearchModel.SORA_2]: ModelVendor.OPENAI,
    [SearchModel.SORA_2_PRO]: ModelVendor.OPENAI,
    [SearchModel.VEO_3_1]: ModelVendor.GOOGLE,
    [SearchModel.VEO_3_1_FAST]: ModelVendor.GOOGLE,
    [SearchModel.SEEDANCE_2_0]: ModelVendor.BYTEDANCE,
    [SearchModel.SEEDANCE_2_5]: ModelVendor.BYTEDANCE,
};
/**
 * Returns a provider/vendor string for a model ID if one is defined in the override map.
 * Returns undefined if the model has no override (i.e. it should come from the API).
 */
export const getSearchModelProvider = (modelId) => SEARCH_MODEL_PROVIDERS[modelId];
//# sourceMappingURL=search-modes.js.map